import React from "react";
import { useFooterQuery } from "./graphql/query";
import LowerFooter from "./components/LowerFooter";
import HomePageUpperFooter from "./components/HomePageUpperFooter";

const HomePageFooterMain = () => {
  const footerData = useFooterQuery();
  return (
    <div>
      <HomePageUpperFooter data={footerData} />
      <LowerFooter data={footerData} />
    </div>
  );
};

export default HomePageFooterMain;
